import { z } from 'zod';

/** Image descriptor shared by catalog, cart, order and content DTOs. */
export const MediaSchema = z.object({
  kind: z.enum(['photo', 'sketch', 'placeholder', 'video']),
  src: z.string().startsWith('/').nullable(),
  alt: z.string(),
  /** CSS object-position, e.g. "50% 30%". */
  position: z.string().nullable(),
  /** Short placeholder label when no photo exists ("Топ", "Коврик"). */
  label: z.string().nullable(),
  /** Prototype disclaimer ("Референс", "Эскиз", "Концепт"); shown only in mock mode. */
  demoTag: z.string().nullable(),
  /** Natural pixel size; sketches are shown at natural size like the design. */
  width: z.number().int().positive().nullable(),
  height: z.number().int().positive().nullable(),
});
export type Media = z.infer<typeof MediaSchema>;
